export enum Entrypoint {
  CMS = 'contact-more-sitters',
  SITTER_PROFILE = 'sitter-profile',
}
